export default __webpack_public_path__ + "static/media/resource-categories.e0a3f253.png";